module.exports = __webpack_public_path__ + "img/EXTERIOR-IGNIS-2021-4.8bacf963.jpg";